export default function TickerTapeBanner() {
  const text = "IGLESIA O MINISTERIO EN ALGÚN LUGAR DEL MUNDO";
  const text2 = "CADA 54 SEGUNDOS, ALGUIEN ENTREGA SU VIDA A JESÚS A TRAVÉS DE UNA AG";
  const separator = <span style={{
    color: '#F73C4A',
    fontSize: '20px',
    fontWeight: 800,
    margin: '0 18px',
    display: 'inline-block'
  }}>
      
    </span>;
  const repeatedContent1 = Array.from({
    length: 8
  }).map((_, i) => <span key={i} style={{
    display: 'inline-flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  }}>
      <span>{text}</span>
      {separator}
    </span>);
  const repeatedContent2 = Array.from({
    length: 8
  }).map((_, i) => <span key={i} style={{
    display: 'inline-flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  }}>
      <span>{text2}</span>
      {separator}
    </span>);
  return <section style={{
    width: '100%',
    height: '288px',
    overflow: 'hidden',
    position: 'relative',
    background: '#F5F4F2'
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@700&display=swap');
        @keyframes marquee1 {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee2 {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .ticker-ribbon-1 {
          position: absolute;
          left: -10%;
          width: 120%;
          background: #fff;
          padding: 14px 0;
          transform: rotate(-3deg);
          top: 74px; /* Ajustado para centrar verticalmente */
          display: flex;
          align-items: center;
          overflow: hidden;
        }
        .ticker-ribbon-2 {
          position: absolute;
          left: -10%;
          width: 120%;
          background: #fff;
          padding: 14px 0;
          transform: rotate(2.5deg);
          top: 164px; /* Ajustado para centrar verticalmente */
          display: flex;
          align-items: center;
          overflow: hidden;
        }
        .ticker-track-1 {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          animation: marquee1 80s linear infinite;
        }
        .ticker-track-2 {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          animation: marquee2 80s linear infinite;
        }
        .ticker-star {
          color: #F73C4A;
          font-size: 20px;
          font-weight: 800;
          margin: 0 16px;
          display: inline-block;
          line-height: 1;
        }
        .ticker-text {
          font-family: 'Switzer', 'Inter', sans-serif;
          font-size: 22px;
          font-weight: 800;
          color: #21211F;
          text-transform: uppercase;
          letter-spacing: 0.02em;
          white-space: nowrap;
        }
      `}</style>

      <div className="ticker-ribbon-1">
        <div className="ticker-track-1 ticker-text">
          {Array.from({
          length: 12
        }).map((_, i) => <span key={i} style={{
          display: 'inline-flex',
          alignItems: 'center'
        }}>
              <span>IGLESIA AD O MINISTERIO EN ALGÚN LUGAR DEL MUNDO</span>
              <span className="ticker-star"></span>
              <span>CADA 54 SEGUNDOS, ALGUIEN ENTREGA SU VIDA A JESÚS A TRAVÉS DE UNA</span>
              <span className="ticker-star"></span>
            </span>)}
        </div>
      </div>

      <div className="ticker-ribbon-2">
        <div className="ticker-track-2 ticker-text">
          {Array.from({
          length: 12
        }).map((_, i) => <span key={i} style={{
          display: 'inline-flex',
          alignItems: 'center'
        }}>
              <span>CADA 54 SEGUNDOS, ALGUIEN ENTREGA SU VIDA A JESÚS A TRAVÉS DE UNA</span>
              <span className="ticker-star"></span>
              <span>IGLESIA AD O MINISTERIO EN ALGÚN LUGAR DEL MUNDO</span>
              <span className="ticker-star"></span>
            </span>)}
        </div>
      </div>
    </section>;
}